import React from 'react'
import { Button } from '@material-ui/core'
import { Col } from 'react-bootstrap'

function SolicitudAnalisisEmbarque () {
  return (
    <>
      <>Filtros completos</>
      <Col md={6}>
        <Button variant='outlined' fullWidth color='default'>
                    Generar solicitud análisis embarque
        </Button>
      </Col>
      <>Listado --</>
    </>
  )
}

export default SolicitudAnalisisEmbarque
